const ENTER_USERNAME = 'enter_username';
const ENTER_OTP = 'enter_otp';
const ENTER_NEW_PASSWORD = 'enter_new_password';

export { ENTER_NEW_PASSWORD, ENTER_OTP, ENTER_USERNAME };
